import React, { Fragment, PureComponent, ReactElement } from 'react';
import { Country } from '~/Api/Country';
import { Currency } from '~/Api/Currency';
import { Product as GeneralProduct } from '~/Api/Product';
import { Product } from '~/Api/User/ProductGroup/CaLabeling';
import { PricedProduct } from '~/Product';

import Header from './Header/Header';
import Row, { EmptyRow, OnChangeListener, Values } from './Row';

export interface ProductRow {
	country: Country;
	product: PricedProduct<Product> | null;
}

export type ProductValues = Values;

interface Props {
	currencies: Currency[] | null;
	currency: string | null;
	disablePackageSize: boolean;
	filterCalculatedPrice: boolean;
	highlightProductId: string | null;
	isFetching: boolean;
	priceType: string | null;
	products: ProductRow[];
	productValues: { [key in string]: Values };
	detailLink(product: { id: string }): { pathname: string; search: string };
	onChange: OnChangeListener;
	onPriceChanged(currency: string | null, priceType: string | null, filterCalculatedPrice: boolean): void;
	onSave(): void;
	checkedRows: GeneralProduct[];
	checkRow(product: GeneralProduct, checked: boolean): void;
}

export default class ProductsTable extends PureComponent<Props> {
	public static defaultProps = {
		disablePackageSize: false,
	};

	public render() {
		const { products, currency, currencies, priceType, filterCalculatedPrice, onPriceChanged } = this.props;

		return (
			<Fragment>
				<Header
					currencies={currencies}
					currency={currency}
					filterCalculatedPrice={filterCalculatedPrice}
					priceType={priceType}
					onPriceChanged={onPriceChanged}
				/>
				{products.map((optionalProduct) => {
					const { country, product } = optionalProduct;
					return product !== null ? this.renderRow(product) : <EmptyRow country={country} key={country.alpha2} />;
				})}
			</Fragment>
		);
	}

	private renderRow(pricedProduct: PricedProduct<Product>) {
		const {
			checkRow,
			productValues,
			highlightProductId,
			priceType,
			isFetching,
			disablePackageSize,
			detailLink,
			onChange,
			onSave,
		} = this.props;
		const { product } = pricedProduct;
		const checked = this.props.checkedRows?.some((row) => row.id === product.id);

		return (
			<Row
				detailLink={detailLink}
				disablePackageSize={disablePackageSize}
				highlightProduct={highlightProductId === product.id}
				checked={checked}
				checkRow={(value) => checkRow(product, value)}
				isFetching={isFetching}
				key={product.id}
				pricedProduct={pricedProduct}
				priceType={priceType}
				values={productValues[product.id]}
				onChange={onChange}
				onSave={onSave}
			/>
		);
	}
}
